import { Dialog } from "primereact/dialog";
import { ScannerContent } from "./ScannerPage";

/// Modal do leitor de QR, aberto pelo botão no cabeçalho.
export function ScannerDialog({ visible, onHide }: { visible: boolean; onHide: () => void }) {
    return (
        <Dialog
            header="Leitor de QR"
            visible={visible}
            onHide={onHide}
            blockScroll
            className="responsive-dialog scanner-dialog"
            breakpoints={{ "700px": "100vw" }}
            style={{ width: "40rem" }}
        >
            <ScannerContent />
        </Dialog>
    );
}
